{
  "tabs": {
    "title": "Bénévolat",
    "teams": "Équipes",
    "trainingModules": "Modules de formation"
  },
  "teams": {
    "heading": "Équipes",
    "newTeam": "Nouvelle équipe",
    "emptyTitle": "Aucune équipe pour l'instant",
    "emptyMessage": "Créez une équipe de bénévoles pour commencer."
  },
  "team": {
    "loadFailedTitle": "Impossible de charger l'équipe",
    "loadFailedMessage": "Cette équipe a peut-être été supprimée.",
    "backToTeams": "Retour aux équipes",
    "noMembers": "Aucun bénévole dans cette équipe. Invitez un bénévole pour commencer.",
    "viewAll_one": "Voir {{count}} bénévole",
    "viewAll_other": "Voir les {{count}} bénévoles",
    "roles": "Rôles",
    "editTeam": "Modifier l'équipe",
    "inviteVolunteer": "Inviter un bénévole",
    "unknownPerson": "Inconnu"
  },
  "menu": {
    "details": "Détails",
    "editRoles": "Modifier les rôles",
    "assignedTraining": "Formations assignées",
    "removeFromTeam": "Retirer de l'équipe"
  },
  "rolePicker": {
    "label": "Rôles"
  },
  "errors": {
    "loadTeams": "Impossible de charger les équipes.",
    "loadTeam": "Impossible de charger cette équipe.",
    "loadTrainingModules": "Impossible de charger les modules de formation.",
    "loadTrainingModule": "Impossible de charger ce module de formation.",
    "loadAssignedTraining": "Impossible de charger les formations assignées.",
    "missingChurch": "Contexte d'église manquant. Veuillez actualiser la page et réessayer."
  },
  "common": {
    "close": "Fermer",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "done": "Terminé",
    "cancel": "Annuler",
    "tryAgain": "Réessayer",
    "back": "Retour",
    "loading": "Chargement…"
  }
}
